<template>
  <div>
    <Header :sel='type' @changePhone="changePhone" />
    <div :class="['cd-main-content', showPhone ? 'nav-is-visible' : '']">
      <!--新闻中心-->
      <div class="bg2">
        <div class="main3">
          <div class="erji">
            <div class="erji_t">{{ level == 0 ? '关键词' : selOneName }}</div>
            <ul class="erji_list" v-if="configList.length > 0">
              <li :class="item.categoryCode == type ? 'erji_cur' : ''"
                @click="selData(item.categoryCode, item.categoryName)" v-for="item in configList">
                <span>></span><a href="javascript:void(0);">{{ item.categoryName }}</a>
              </li>
            </ul>
          </div>
          <div class="neirong_r">
            <div class="bread">
              <div class="bread_t">{{ level == 0 ? (title ? ('关键词：' + title) : '关键词') : (selName ? selName : selOneName)
              }}
              </div>
              <div class="bread_c" v-if="level == 0">为您找到相关结果{{ total }}个</div>
              <div class="bread_c" v-else><a href="javascript:void(0);" @click="goNext('/')">主页</a> > <a
                  href="javascript:void(0);">{{ selOneName }}</a><a href="javascript:void(0);" v-if="selName">>
                  {{ selName }}</a> </div>
            </div>
            <div class="main_line2">&nbsp;</div>
            <div class="neirong_c">

              <ul class="shihua_list" v-if="selOneName == '保险史志'">
                <li v-for="item in list"><a href="javascript:void(0);" @click="goProDetail(item.id)"><img
                      :src="item.image" />
                    <p>{{ item.title }}</p>
                  </a></li>
                <!-- <li v-for="item in list"><span>{{item.publishTime}}</span> <a href="javascript:void(0);" @click="goDetail(item.id)">{{item.title}}</a> </li> -->
              </ul>
              <div v-else-if="selOneName == '关于学会'">
                <ul class="leader_list" v-if="selName == '学会领导'">

                  <li v-for="item in list"><a href="javascript:void(0);" @click="goDetail(item.id, item.linkUrl)">
                      <div class="leader_t">{{ item.title }}</div>
                      <div class="leader_c ellipsis-2">
                        {{ item.describtion }}
                      </div>
                    </a></li>
                </ul>
                <img :src="xhDetail.image" v-else-if="selName == '组织架构'" />
                <div v-else v-html="xhDetail.cmsArticleData ? xhDetail.cmsArticleData.content : ''"></div>
              </div>



              <ul class="news_list" v-else>
                <li v-for="item in list"><span>{{ item.publishTime }}</span> <a href="javascript:void(0);"
                    @click="goDetail(item.id, item.linkUrl)">{{ item.title }}</a> </li>

              </ul>
              <ul id="page" v-if="!(selOneName == '关于学会' && selName != '学会领导')">
                <li><a href="javascript:void(0)" @click="goPage('home')">首页</a></li>
                <li><a href="javascript:void(0)" @click="goPage('last')">上一页</a></li>
                <li v-for="index in indexs" @click="goPage(index)"><a :class="pageNum == index ? 'pagesel' : ''"
                    href="javascript:void(0)">{{ index }}</a>
                </li>
                <li><a href="javascript:void(0)" @click="goPage('next')">下一页</a></li>
                <li><a href="javascript:void(0)" @click="goPage('end')">尾页</a></li>
                <li class="total">共{{ totalPage }}页</li>
              </ul>
            </div>
          </div>
        </div>
        <div class="clear"></div>
      </div>
      <!--新闻中心-->
      <Footer></Footer>

    </div>


  </div>
</template>

<script>
import Header from '@/components/header.vue'
import Footer from '@/components/footer.vue'
import {
  categorysortPage,
  articleList,
  articleDetail
} from '@/api/reqFetch.js'
export default {
  name: '',
  layout: '',
  components: {
    Footer,
    Header
  },
  data() {
    return {
      tabList: [],
      selName: '',
      selid: '0',
      list: [],
      pageNum: 1,
      indexs: [],
      totalPage: 0,
      showPhone: false,
      type: '',
      categoryCode: '',
      configList: [],
      selOneName: '',
      title: '',
      total: 0,
      level: 1,
      firstCategoryCode: '',
      pos: '',
      xhDetail: {},
      id: ''
    }
  },

  mounted() {
    if (this.$route.query.type) {
      this.type = this.$route.query.type
      this.categoryCode = this.type
    }
    if (this.$route.query.title) {
      this.title = this.$route.query.title
    }
    if (this.$route.query.firstCategoryCode) {
      this.firstCategoryCode = this.$route.query.firstCategoryCode
    }
    this.level = this.$route.query.level
    if (this.$route.query.type == '10008') {
      //关于学会强制转换
      this.type = '20001'
      this.categoryCode = '20001'
      this.firstCategoryCode = '10008'
      this.level = '2'
    }
    this.pos = this.$route.query.pos ? this.$route.query.pos : 'top'


    this.checkCategoryCode()

  },

  methods: {
    checkCategoryCode() {
      categorysortPage({
        pos: this.pos
      }).then(res => {
        if (this.level == 1) {
          res.data.map(item => {
            if (item.categoryCode == this.type) {
              this.selOneName = item.categoryName
              this.configList = item.children
              if (this.configList.length > 0) {
                this.selName = this.configList[0].categoryName
                this.categoryCode = this.configList[0].categoryCode
                this.type = this.configList[0].categoryCode
              }
            }
          })
          if (this.$route.query.static) {
            this.selOneName = '学习贯彻二十届四中全会精神'
          }
          this.getData()
        } else {
          res.data.map(item => {
            if (item.categoryCode == this.firstCategoryCode) {
              this.selOneName = item.categoryName
              this.configList = item.children
              this.configList.map(items => {
                if (items.categoryCode == this.type) {
                  this.selName = items.categoryName
                }
              })
            }
          })
          this.getData()
        }

      });
    },
    changePhone(val) {
      this.showPhone = val
    },
    goNext(url) {
      this.$router.push({
        path: url,
      })
    },

    selData(id, name) {
      this.selName = name
      this.type = id
      this.categoryCode = id
      this.getData()
    },
    checkIndex() {
      var left = 1;
      var right = this.totalPage;
      var ar = [];
      if (this.totalPage >= 10) {
        if (this.pageNum > 1 && this.pageNum < this.totalPage - 2) {
          left = this.pageNum - 1
          right = this.pageNum + 1
        } else {
          if (this.pageNum <= 1) {
            left = 1
            right = 10
          } else {
            right = this.totalPage
            left = this.totalPage - 2
          }
        }
      }
      while (left <= right) {
        ar.push(left)
        left++
      }
      this.indexs = ar

    },
    goPage(type) {
      if (type == 'home') {
        this.pageNum = 1
      } else if (type == 'end') {
        this.pageNum = Number(this.totalPage)

      } else if (type == 'last') {
        if (this.pageNum > 1) {
          this.pageNum = this.pageNum - 1
        }
      } else if (type == 'next') {
        if (this.pageNum < (this.totalPage)) {
          this.pageNum = this.pageNum + 1
        }
      } else {
        this.pageNum = type
      }
      this.getData()
    },
    init() {
      //this.params.pageNumber=1;
      this.getData()
    },
    getNewDetail() {
      articleDetail({
        id: this.id
      }).then(res => {
        this.xhDetail = res.data;
      });
    },
    getData() {
      let par = {
        pageNum: this.pageNum,
        pageSize: 10,
        status: 1,
      }
      if (this.categoryCode) {
        par.categoryCode = this.categoryCode
      }
      if (this.title) {
        par.title = this.title
      }
      articleList(par).then(res => {
        this.list = res.rows;
        this.total = res.total
        this.totalPage = Math.ceil(res.total / 10)
        this.checkIndex();
        this.xhDetail = {}
        if (par.categoryCode == '20001' || par.categoryCode == '20002' || par.categoryCode ==
          '20003' || par.categoryCode == '20004' || par.categoryCode == '20005') {
          this.id = res.rows[0].id
          this.getNewDetail()
        }
      });
    },
    goDetail(id, url) {
      if (url) {
        window.open(url, '_blank');
        return
      }
      let data = {
        path: '/context',
        query: {
          id: id
        }
      }
      if (this.type == '12000') {
        data.query.simple = true
      }
      const route = this.$router.resolve(data);
      window.open(route.href, '_blank');
    },
    goProDetail(id) {
      const route = this.$router.resolve({
        path: '/productDetail',
        query: {
          id: id
        }
      });
      window.open(route.href, '_blank');
    },

  }
}
</script>

<style scoped>
.banner {
  /* background-image: url('../../assets/images/banner_03.png'); */
}
</style>